<template>
  <v-container
      fluid
  >
    <SaveForm :isEdit="isEdit" :urlId="urlId" title="担当者編集"></SaveForm>
  </v-container>
</template>

<script>
import SaveForm from "./components/SaveForm";

export default {
  components: {SaveForm},
  data: () => ({
    urlId: '',
    isEdit: false
  }),
  created() {
    this.initialize()
  },
  methods: {
    async initialize() {
      //urlに設定されたidを取得
      this.urlId = this.$route.params.id
      if(this.urlId) {
        this.isEdit = true
      } else {
        await this.$router.push('/')
      }
    },
  }
}
</script>

<style scoped>

</style>